import React, { Component } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  CustomInput,
  Row,
  Col,
} from "reactstrap";
import Switch from "rc-switch";
import "rc-switch/assets/index.css";
import IntlMessages from "../../helpers/IntlMessages";
import { Colxx } from "../../components/common/CustomBootstrap";

class BookingSettingsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      setting: this.props.setting || {
        booking_enabled: true,
        auto_confirm: false,
        max_party_size: 20,
        min_advance_hours: 2,
        max_advance_days: 30,
        default_duration: 120,
        deposit_required: false,
        deposit_amount: 0,
        send_confirmation_email: true,
        send_reminder_email: true,
        reminder_hours_before: 2,
      },
      copied: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.setting !== this.props.setting && this.props.setting) {
      this.setState({ setting: { ...this.props.setting } });
    }
    // Khi modal mở ra, nếu có setting thì cập nhật lại state
    if (
      prevProps.isOpen !== this.props.isOpen &&
      this.props.isOpen &&
      this.props.setting
    ) {
      this.setState({ setting: { ...this.props.setting } });
    }
  }

  handleChange = (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState((prevState) => ({
      setting: {
        ...prevState.setting,
        [name]: value,
      },
    }));
  };

  handleSave = () => {
    this.props.onSave(this.state.setting);
  };

  getBookingLink = () => {
    const username = localStorage.getItem("username") || "";
    const origin = window.location.origin;
    // const origin = 'localhost:8080';
    let baseUrl = origin;
    if (!origin.includes("localhost")) {
      baseUrl = "https://vmass.vn";
    }
    return `${baseUrl}/booking-online/${username}`;
  };

  copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      this.setState({ copied: true });
      setTimeout(() => this.setState({ copied: false }), 2000);
    });
  };

  render() {
    const { isOpen, toggle } = this.props;
    const { setting } = this.state;

    return (
      <Modal isOpen={isOpen} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>
          <IntlMessages
            id="booking.settings"
            defaultMessage="Cài đặt đặt bàn"
          />
        </ModalHeader>
        <ModalBody>
          <Row>
            <Colxx xxs="12">
              <FormGroup>
                <Label className="font-weight-bold">
                  Link đặt bàn cho khách (Gửi link này cho khách hàng)
                </Label>
                <div className="d-flex">
                  <Input readOnly value={this.getBookingLink()} />
                  <Button
                    color="primary"
                    className="ml-2"
                    style={{ minWidth: "100px" }}
                    onClick={() => this.copyToClipboard(this.getBookingLink())}
                  >
                    {this.state.copied ? "Đã sao chép!" : "Sao chép"}
                  </Button>
                </div>
              </FormGroup>
              <hr />
              <h5 className="mb-3">
                <i className="simple-icon-settings mr-2" />
                Cấu hình chung
              </h5>
              <FormGroup>
                <Label className="d-flex align-items-center">
                  <Switch
                    className="custom-switch custom-switch-primary"
                    checked={setting.booking_enabled}
                    onChange={(checked) =>
                      this.handleChange({
                        target: {
                          name: "booking_enabled",
                          type: "checkbox",
                          checked: checked,
                        },
                      })
                    }
                  />
                  <span className="ml-2">Kích hoạt tính năng đặt bàn</span>
                </Label>
              </FormGroup>

              {setting.booking_enabled && (
                <>
                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label className="d-flex align-items-center">
                          <Switch
                            className="custom-switch custom-switch-primary"
                            checked={setting.auto_confirm}
                            onChange={(checked) =>
                              this.handleChange({
                                target: {
                                  name: "auto_confirm",
                                  type: "checkbox",
                                  checked: checked,
                                },
                              })
                            }
                          />
                          <span className="ml-2">Tự động xác nhận đặt bàn</span>
                        </Label>
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label>Thời lượng mặc định (phút)</Label>
                        <Input
                          type="number"
                          name="default_duration"
                          value={setting.default_duration}
                          onChange={this.handleChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <hr />
                  <h5 className="mb-3">
                    <i className="simple-icon-clock mr-2" />
                    Giới hạn & Thời gian
                  </h5>
                  <Row>
                    <Col md="4">
                      <FormGroup>
                        <Label>Số khách tối đa / bàn</Label>
                        <Input
                          type="number"
                          name="max_party_size"
                          value={setting.max_party_size}
                          onChange={this.handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup>
                        <Label>Đặt trước tối thiểu (giờ)</Label>
                        <Input
                          type="number"
                          name="min_advance_hours"
                          value={setting.min_advance_hours}
                          onChange={this.handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup>
                        <Label>Đặt trước tối đa (ngày)</Label>
                        <Input
                          type="number"
                          name="max_advance_days"
                          value={setting.max_advance_days}
                          onChange={this.handleChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <hr />
                  <h5 className="mb-3">
                    <i className="simple-icon-wallet mr-2" />
                    Đặt cọc
                  </h5>
                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <CustomInput
                          type="checkbox"
                          id="deposit_required"
                          name="deposit_required"
                          label="Yêu cầu đặt cọc"
                          checked={setting.deposit_required}
                          onChange={this.handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label>Số tiền cọc cố định (VNĐ)</Label>
                        <Input
                          type="number"
                          name="deposit_amount"
                          value={setting.deposit_amount}
                          onChange={this.handleChange}
                          disabled={!setting.deposit_required}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <hr />
                  <h5 className="mb-3">
                    <i className="simple-icon-envelope mr-2" />
                    Thông báo Email
                  </h5>
                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <CustomInput
                          type="checkbox"
                          id="send_confirmation_email"
                          name="send_confirmation_email"
                          label="Gửi email xác nhận đặt bàn"
                          checked={setting.send_confirmation_email}
                          onChange={this.handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <CustomInput
                          type="checkbox"
                          id="send_reminder_email"
                          name="send_reminder_email"
                          label="Gửi email nhắc sắp đến giờ đặt bàn"
                          checked={setting.send_reminder_email}
                          onChange={this.handleChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  {setting.send_reminder_email && (
                    <Row>
                      <Col md="12">
                        <FormGroup>
                          <Label>Gửi nhắc nhở trước (giờ)</Label>
                          <Input
                            type="number"
                            name="reminder_hours_before"
                            value={setting.reminder_hours_before}
                            onChange={this.handleChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  )}
                </>
              )}
            </Colxx>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Hủy
          </Button>
          <Button color="primary" onClick={this.handleSave}>
            Lưu cài đặt
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default BookingSettingsModal;
